import React, { useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { URLBunge } from "./Componentes/Config";
import { AlertForm, AlertRedirect, maskLoginSympla, MostrarIngresso, hexToRgbA } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import Rodape from "./Componentes/Rodape";

import {
  BackgroundImg,
  Coluna,
  CampoFormCadastro,
  FormCadastro,
  BotaoEntrar,
  LogoMinhaBunge,
  IcoForm,
  BtEsqueciSenha,
  Clear,
  LogoBunge,
  BotaoCadastro,
  FooterLogin,
  TopNavegacao,
  BtSetaVoltar,
  TitItem,
  DoisCampos,
  CheckBox,
  ModalEvento
} from './Estilos'

import ImgLogoMinhaBunge from "./Images/LogoMinhaBunge.png"
import BackgroundPagina from "./Images/BgBunge.jpg"
import ImgIcoEnvelope from "./Images/ico_envelope.png"
import ImgIcoCadeado from "./Images/ico_cadeado.png"
import ImgLogoBunge from "./Images/LogoBunge.png"

function Cadastro() {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ IpClient, SetIpClient ] = useState("");
  const [ EmailInvalido, setEmailInvalido ] = useState(false);
  const [CheckBoxTermosUso, setCheckBoxTermosUso] = useState(false);

  const Estados = [
    { value: 'AC', label: 'Acre' },
    { value: 'AL', label: 'Alagoas' },
    { value: 'AP', label: 'Amapá' },
    { value: 'AM', label: 'Amazonas' },
    { value: 'BA', label: 'Bahia' },
    { value: 'CE', label: 'Ceará' },
    { value: 'DF', label: 'Distrito Federal' },
    { value: 'ES', label: 'Espírito Santo' },
    { value: 'GO', label: 'Goiás' },
    { value: 'MA', label: 'Maranhão' },
    { value: 'MT', label: 'Mato Grosso' },
    { value: 'MS', label: 'Mato Grosso do Sul' },
    { value: 'MG', label: 'Minas Gerais' },
    { value: 'PA', label: 'Pará' },
    { value: 'PB', label: 'Paraíba' },
    { value: 'PR', label: 'Paraná' },
    { value: 'PE', label: 'Pernambuco' },
    { value: 'PI', label: 'Piauí' },
    { value: 'RJ', label: 'Rio de Janeiro' },
    { value: 'RN', label: 'Rio Grande do Norte' },
    { value: 'RS', label: 'Rio Grande do Sul' },
    { value: 'RO', label: 'Rondônia' },
    { value: 'RR', label: 'Roraima' },
    { value: 'SC', label: 'Santa Catarina' },
    { value: 'SP', label: 'São Paulo' },
    { value: 'SE', label: 'Sergipe' },
    { value: 'TO', label: 'Tocantins' }
  ];


  const onSubmit = async (data, e) => {  

    if(data.c_nome == "" || data.c_nome == undefined){
      AlertForm('O campo NOME é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_cpf == "" || data.c_cpf == undefined){
      AlertForm('O campo CPF é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_email == "" || data.c_email == undefined){
      AlertForm('O campo E-MAIL é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data.c_email)) {
      AlertForm('O formato campo E-MAIL está incorreto!');
      e.preventDefault();
      return false
    }

    if(data.c_celular == "" || data.c_celular == undefined){
      AlertForm('O campo CELULAR é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_cep == "" || data.c_cep == undefined){
      AlertForm('O campo CEP é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_endereco == "" || data.c_endereco == undefined){
      AlertForm('O campo ENDEREÇO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_numero == "" || data.c_numero == undefined){
      AlertForm('O campo NÚMERO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_bairro == "" || data.c_bairro == undefined){
      AlertForm('O campo BAIRRO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_cidade == "" || data.c_cidade == undefined){
      AlertForm('O campo CIDADE é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_estado == 0){
      AlertForm('O campo ESTADO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_senha == "" || data.c_senha == undefined){
      AlertForm('O campo SENHA é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }
    
    if(data.c_confirmasenha !== data.c_senha){
      AlertForm('As senhas digitadas não coincidem!');
      e.preventDefault();
      return false
    }

    if( CheckBoxTermosUso == false ){
      AlertForm('Você precisa aceitar os termos de uso e LGPD.');
      e.preventDefault();
      return false
    }

    setLoading(true);

    var DDDCel = data.c_celular
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(0,2);

    var Celular = data.c_celular
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(2,9);

    var DDDTel = data.c_telefone
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(0,2)

    var Telefone = data.c_telefone
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(2,8)

    var CEP = data.c_cep
    .replace('-', '')

    var CPF = data.c_cpf
    .replace('.','')
    .replace('.','')
    .replace('-', '')

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "nome": data.c_nome,
      "cpf": CPF,
      "apelido": data.c_apelido,
      "email": data.c_email,
      "telefone": DDDTel+Telefone,
      "celular": DDDCel+Celular,
      "cep": CEP,
      "endereco": data.c_endereco,
      "numeroEndereco": data.c_numero == "" ? null : data.c_numero,
      "complementoEndereco": data.c_complemento,
      "bairro": data.c_bairro,
      "cidade": data.c_cidade,
      "estado": data.c_estado,
      "senha": data.c_senha,
      "confirmarSenha": data.c_confirmasenha,
      "origem": 1072
    });

    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Cliente/CadastrarEntidade`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result);

        if(result.sucesso === false) {

          AlertForm(result.mensagem);
          setLoading(false);

        } else {

          AlertRedirect(result.mensagem, 'login', history);
          setLoading(false);

        }

      })
      .catch(error => console.log('error', error));

    


  };

  function AbreTexto(Tipo) {
    setTipoTexto(Tipo);
    setMostraNovoEvento(!MostraNovoEvento);
  }

  const [TextoTermosUso, setTextoTermosUso] = useState("");
  const [TituloTermosUso, setTituloTermosUso] = useState("");

  const [TextoLGPD, setTextoLGPD] = useState("");
  const [TituloLGPD, setTituloLGPD] = useState("");

  useEffect(() => {

    var requestOptions = { method: 'GET', redirect: 'follow' };
    
    fetch(`${URLBunge}/api/Regulamentos/ListaRegulamentosTipo/1`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setTituloTermosUso(result.regulamentos[0].descricao);
        setTextoTermosUso(result.regulamentos[0].regulamento);
      })
      .catch(error => console.log('error', error));

    
    fetch(`${URLBunge}/api/Regulamentos/ListaRegulamentosTipo/2`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setTituloLGPD(result.regulamentos[0].descricao);
        setTextoLGPD(result.regulamentos[0].regulamento);
      })
      .catch(error => console.log('error', error));

  }, []);

  const [ TipoTexto, setTipoTexto ] = useState(0);
  const [ MostraNovoEvento, setMostraNovoEvento ] = useState(false);
  const MostrarEvento = (props) => {
    return <>
      <ModalEvento>
        <div className={'TextoEvento'} style={{textAlign: 'left'}}>

          {TipoTexto === 0 ?
          <><div className={'TituloEvento'}>{TituloTermosUso}</div> {TextoTermosUso}</>
          :
          <><div className={'TituloEvento'}>{TituloLGPD}</div> {TextoLGPD}</>
          }

        </div>
        <a className={'BtFecharModal'} onClick={()=>setMostraNovoEvento(false)}>FECHAR</a>
      </ModalEvento>
    </>
  }


  return (
    <>
        <CabecalhoPagina NomeEvento={NomeEvento} />

        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={BackgroundPagina} BackgroundMob={BackgroundPagina} bgcolor={'#191919'}>

          <TopNavegacao>
            <Coluna>
              <BtSetaVoltar onClick={ ()=> history.push({ pathname: 'login', state: {} }) }/>
              <TitItem>CADASTRO</TitItem>
            </Coluna>
          </TopNavegacao>

          <Coluna>





          {MostraNovoEvento === true ? <MostrarEvento /> : null }

          <LogoMinhaBunge src={ImgLogoMinhaBunge} MaxWidth={'120px'} />


            {/* <div onClick={()=>AlertRedirect('texto blablabla lalalala', 'login', history)}>xxxsssddd</div> */}



            <FormCadastro onSubmit={handleSubmit(onSubmit)}>


              <DoisCampos>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_nome"
                    name="c_nome"
                    type="text"
                    placeholder={'Nome completo'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_apelido"
                    name="c_apelido"
                    type="text"
                    placeholder={'Apelido'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>
              </DoisCampos>

              <DoisCampos>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_cpf"
                    name="c_cpf"
                    type="text"
                    placeholder={'CPF'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask="999.999.999-99"
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_email"
                    name="c_email"
                    type="text"
                    placeholder={'E-mail'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>
              </DoisCampos>


              <DoisCampos>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_telefone"
                    name="c_telefone"
                    type="text"
                    placeholder={'Telefone'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask="(99) 9999-9999"
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_celular"
                    name="c_celular"
                    type="text"
                    placeholder={'Celular'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask="(99) 9999-99999"
                  />
                </CampoFormCadastro>
              </DoisCampos>



              <DoisCampos>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_cep"
                    name="c_cep"
                    type="text"
                    placeholder={'CEP'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask="99999-999"
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_endereco"
                    name="c_endereco"
                    type="text"
                    placeholder={'Endereço'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>
              </DoisCampos>




              <DoisCampos>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_numero"
                    name="c_numero"
                    type="text"
                    placeholder={'Número'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_complemento"
                    name="c_complemento"
                    type="text"
                    placeholder={'Complemento'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>
              </DoisCampos>





              <DoisCampos>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_bairro"
                    name="c_bairro"
                    type="text"
                    placeholder={'Bairro'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_cidade"
                    name="c_cidade"
                    type="text"
                    placeholder={'Cidade'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <select name={"c_estado"} id={"c_estado"} ref={register}>
                    <option value={0} disabled selected>Selecione</option>
                    {
                      Estados.map((item, index) => {
                        return <> <option value={item.value}>{item.label}</option> </>
                      })
                    }
                  </select>
                </CampoFormCadastro>
              </DoisCampos>


              <DoisCampos>
                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_senha"
                    name="c_senha"
                    type="password"
                    placeholder={'Senha'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>

                <CampoFormCadastro>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_confirmasenha"
                    name="c_confirmasenha"
                    type="password"
                    placeholder={'Confirmar senha'}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                </CampoFormCadastro>
              </DoisCampos>

              <CheckBox>
                <input name="isGoing" type="checkbox" checked={CheckBoxTermosUso} onChange={()=>setCheckBoxTermosUso(!CheckBoxTermosUso)} />
                <div>Aceito os <span onClick={()=>AbreTexto(0)}>termos de uso</span> e <span onClick={()=>AbreTexto(1)}>LGPD</span></div>
              </CheckBox>

              <BotaoEntrar type="submit">ENTRAR</BotaoEntrar>
              <Clear />

              <FooterLogin> <LogoBunge src={ImgLogoBunge} /> </FooterLogin>

            </FormCadastro>

          </Coluna>
        </BackgroundImg>

    </>
  );
}

export default Cadastro;
